/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { object } from 'prop-types';
import Media from 'react-media';
import NupV3 from '../../../../ContentTypeComponents/NupV3/NupV3';
import useSSRMediaQuery from '../../../../../helpers/hooks/useSSRMediaQuery';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .nup-v3-container': {
            width: '100%',
            padding: 0,
            margin: '1.688rem 0.5rem 1.188rem',
            maxWidth: '100%',
            overflow: 'auto',
            [theme.breakpoints.up(600)]: {
                justifyContent: 'center',
            },
        },
        '& .nup-v3-panel-item': {
            fontSize: 12,
            margin: '4px 0px 6px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '16px',
            letterSpacing: '0em',
            textAlign: 'center',
            [theme.breakpoints.up(600)]: {
                fontSize: '1rem',
            },
        },
        '& .nup-v3-grid-container': {
            gap: '0.75rem',
            [theme.breakpoints.up(600)]: {
                gap: '1.25rem',
            },
        },
    },
}));

const PLAPDPIcon = ({
    blockData,
}) => {
    const classes = useStyles();
    const deviceType = useSSRMediaQuery();

    const renderNupPanel = (isTrue = false) => (
        <div className={classes.root}>
            <NupV3
                sectionStyling={{
                    width: isTrue ? '176px' : '85px',
                    insetBorder: {
                        border: isTrue ? '1px solid #D9D9D9' : '0px',
                        padding: isTrue ? 'clamp(0px, 1vw, 8px)' : 'clamp(0px, 1vw, 0px)',
                    },
                }}
                data={{
                    reference: [blockData],
                }}
            />
        </div>
    );
    return (
        <Media query={{ minWidth: 601 }} defaultMatches={deviceType === 'desktop'}>
            {(matches) => (
                <>
                    {matches ? renderNupPanel(true) : renderNupPanel(false)}
                </>
            )}
        </Media>
    );
};

PLAPDPIcon.propTypes = {
    blockData: object,
};

PLAPDPIcon.defaultProps = {
    blockData: {},
};

export default PLAPDPIcon;
